import React, { Fragment } from "react";
import Footer from "./Footer";
import HeroPhoto from "./HeroPhoto";

const Experiencia = () => {
  const contactos = [
    { label: "Email", value: "koeman1976sf@gmail.com", href: "mailto:koeman1976sf@gmail.com" },
    { label: "Web", value: "joseanavas.com", href: "https://www.joseanavas.com" },
    {
      label: "LinkedIn",
      value: "Perfil",
      href: "https://www.linkedin.com/in/jose-antonio-navas-ruiz-25694859/",
    },
    { label: "X / Twitter", value: "@koeman1976", href: "https://twitter.com/koeman1976?s=09" },
  ];

  const experiencia = [
    {
      puesto: "Responsable de IT y Desarrollo",
      empresa: "WGM S.L.",
      periodo: "01/2007 – Actualidad",
      tags: ["Operación", ".NET", "SQL Server", "Azure/IIS", "Integración"],
      bullets: [
        "Arquitectura y evolución de plataforma GMAO/CMMS (web enterprise) en entorno crítico.",
        "Integraciones corporativas mediante APIs REST y ficheros JSON a medida por cliente.",
        "Resolución de incidencias complejas en producción con foco en estabilidad y rendimiento.",
        "Administración/despliegue en IIS y Azure VM.",
      ],
      extra:
        "Stack habitual: .NET Framework / WebForms, SQL Server, Telerik, Power BI y desarrollos puntuales en React/Xamarin.",
    },
    {
      puesto: "Jefe / Responsable de Turno",
      empresa: "Inforsistem",
      periodo: "03/1998 – 01/2007",
      tags: ["Operación", "Calidad", "Continuidad", "Clientes grandes"],
      bullets: [
        "Coordinación de equipos y gestión de recursos para producción documental masiva.",
        "Control de calidad, plazos y continuidad del servicio.",
        "Entorno con clientes de gran volumen: La Caixa, Telefónica y Banco Sabadell.",
      ],
      extra: "",
    },
  ];

  return (
    <Fragment>
      <main className="cvMain">
        {/* HERO SIMPLE (sin menú) */}
        <section className="cvHero cvHero2026">
          <div className="cvContainer cvHeroGrid">
            <div className="cvHeroLeft">
              <p className="cvKicker">Experiencia</p>
              <h1 className="cvTitle">Jose Antonio Navas</h1>
              <p className="cvSubtitle">Responsable IT / .NET Senior</p>

              <div className="cvMeta">
                <span className="cvMetaItem">Madrid</span>
                <span className="cvMetaDot" aria-hidden="true" />
                <span className="cvMetaItem">Operación · Arquitectura · Integración</span>
              </div>
            </div>

            <aside className="cvHeroRight" aria-label="Fotografía">
              <HeroPhoto />
            </aside>
          </div>
        </section>

        {/* CONTENIDO EN 2 COLUMNAS */}
        <section className="cvSection">
          <div className="cvContainer cvTwoCol">
            {/* Lateral */}
            <aside className="cvSide">
              <div className="cvCard">
                <h2 className="cvH2">Perfil</h2>
                <p className="cvP">
                  Responsable IT y Desarrollo con experiencia en plataformas empresariales .NET y SQL
                  Server. Especializado en operación de entornos críticos, integraciones y evolución
                  controlada de sistemas legacy con foco en fiabilidad y rendimiento.
                </p>
              </div>

              <div className="cvCard">
                <h2 className="cvH2">Contacto</h2>
                <ul className="cvList">
                  {contactos.map((c) => (
                    <li key={c.label} className="cvListItem">
                      <span className="cvMuted">{c.label}:</span>{" "}
                      <a className="cvLink" href={c.href} target="_blank" rel="noreferrer">
                        {c.value}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="cvCard">
                <h2 className="cvH2">Idiomas</h2>
                <ul className="cvList">
                  <li className="cvListItem">
                    Español <span className="cvMuted">(Nativo)</span>
                  </li>
                  <li className="cvListItem">
                    Inglés <span className="cvMuted">(Medio/Alto)</span>
                  </li>
                </ul>
              </div>
            </aside>

            {/* Principal */}
            <div className="cvContent">
              <div className="cvSectionHead">
                <h2 className="cvH2">Experiencia profesional</h2>
                <p className="cvMuted">Roles, responsabilidades y foco técnico/operativo.</p>
              </div>

              <div className="cvTimeline">
                {experiencia.map((e) => (
                  <article key={`${e.empresa}-${e.periodo}`} className="cvCard cvItem">
                    <div className="cvItemHead">
                      <div>
                        <h3 className="cvH3">
                          {e.puesto} · {e.empresa}
                        </h3>
                        <p className="cvMuted">{e.periodo}</p>
                      </div>

                      <div className="cvTags">
                        {e.tags.map((t) => (
                          <span key={t} className="cvTag">
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>

                    <ul className="cvBullets">
                      {e.bullets.map((b, idx) => (
                        <li key={idx}>{b}</li>
                      ))}
                    </ul>

                    {e.extra ? <p className="cvMuted">{e.extra}</p> : null}
                  </article>
                ))}
              </div>

              {/* CTA */}
              <div className="cvCard cvCtaCard" style={{ marginTop: 14 }}>
                <div>
                  <h2 className="cvH2">¿Hablamos?</h2>
                  <p className="cvP">
                    Si buscas alguien que combine operación real, evolución de legacy crítico y
                    ejecución .NET con criterio, estoy disponible.
                  </p>
                </div>
                <div className="cvCtas">
                  <a className="cvBtnPrimary" href="mailto:koeman1976sf@gmail.com">
                    Contactar
                  </a>
                  <a
                    className="cvBtnGhost"
                    href="https://www.linkedin.com/in/jose-antonio-navas-ruiz-25694859/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </Fragment>
  );
};

export default Experiencia;
